module.exports = __webpack_public_path__ + "img/图片.a393d841.png";